import React, { useState } from 'react';
import Icon from './Icon';

export default function FAQ({ items = [] }) {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="faq-list">
      {items.map((item, i) => {
        const isOpen = openIdx === i;
        return (
          <div
            key={item.q}
            className={`faq-item ${isOpen ? 'is-open' : ''}`}
          >
            <button
              type="button"
              className="faq-question"
              aria-expanded={isOpen}
              onClick={() => setOpenIdx(isOpen ? -1 : i)}
            >
              <span>{item.q}</span>
              <span className={`faq-chevron ${isOpen ? 'rotated' : ''}`}>
                <Icon name="chevron-down" size={20} />
              </span>
            </button>
            <div className="faq-answer-wrap" style={{ maxHeight: isOpen ? 400 : 0 }}>
              <p className="faq-answer">{item.a}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
